// import Navbar from "../../components/navbar/Navbar";
// import Footer from "../../components/footer/Footer";
// import Header from "../../components/header/Header";
import {Link} from "react-router-dom";
import {getFetcher} from '../../../api/fetchers.ts';
import { useEffect, useState } from "react";
import { endpoints } from "../../../api/endpoints.ts";
import Spinner from "../../components/spinner/Spinner.tsx";



const CompanyCampaigns = () => {
    const [companyCampaigns, setCompanyCampaigns] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    // Fetch company campaigns
    useEffect(() => {
            const fetchCompanyCampaigns = async () => {
                setIsLoading(true);
                try {
                    const response = await getFetcher(`${endpoints.campaigns.getCompanyCampaigns}`);
                    if (response.result) {
                        const sortedCampaigns = response.companyCampaigns.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
                        setCompanyCampaigns(sortedCampaigns);
                    } else {
                        console.log(response.message);
                    }
                } catch (error) {
                    console.error("Error fetching favorites data:", error);
                }finally {
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 500);
                }
            };
            fetchCompanyCampaigns();
    }, []);



    // loading spinner
    if (isLoading) {
        return (
            <div className="flex flex-col min-h-screen">
                {/* <Header />
                <Navbar /> */}
                <main className="flex-grow flex justify-center items-center">
                    <Spinner  />
                </main>
                {/* <Footer /> */}
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen">
            {/* <Header/>
            <Navbar/> */}
            <main className="flex-grow p-6 mb-20">
                <div className="max-w-7xl mx-auto bg-white rounded-lg ">
                    {/* HEADER */}
                    <h1 className="text-3xl font-semibold text-primary-color text-center mb-8">
                        Şirket Kampanyaları
                    </h1>
                    {/* CARDS */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                        {companyCampaigns.length>0 ? companyCampaigns.map((campaign, index) => (
                            //<Link to={`/campaigns/${campaign.name.toLowerCase().replace(/\s+/g, '-')}`} key={index}>
                            <Link to={`/company-campaigns/company-camp/${campaign.supplierId}`} key={index}>
                                <div key={index} className="bg-white rounded-lg shadow-md flex gap-8 m-5">
                                    <img src={campaign.image ? campaign.image : 'https://static.thenounproject.com/png/4595376-200.png' } alt={campaign.name}
                                         className="w-2/5 h-36 object-cover rounded-lg"/>
                                    <div className="p-4 flex flex-col justify-center flex-grow space-y-2 w-3/5">
                                        <h3 className="text-lg font-bold text-gray-800">{campaign.supplier.marketPlaceName}</h3>
                                        <h6 className=" font-semibold text-primary-color">{campaign.title}</h6>
                                        <p className="text-xs text-gray-600 mt-2 line-clamp-4">{campaign.description}</p>
                                    </div>
                                </div>
                            </Link>

                        ))
                    : <div className="w-full flex justify-center items-center h-40 md:h-60 lg-80">
                    <p className="text-center text-lg text-primary-color">Henüz kampanya bulunmamaktadır.</p>    
                        </div>
                    }
                    </div>
                </div>
            </main>
            {/* <Footer/> */}
        </div>
    );
};

export default CompanyCampaigns;